<div class="code-container" [ngClass]="{'with-line-numbers': showLineNumbers}">
    @if (showLineNumbers){
        <div class="line-numbers-wrapper">
            @for (lineNum of lineNumbers; track lineNum) {
            <span class="line-number"
                [class.highlighted]="highlightedLineSet.has(+lineNum)">{{lineNum}}</span>
            }
        </div>
    }

    <div class="code-wrapper">
        @for (line of highlightedLineList; track line) {
            <div class="line-highlight" [style.top]="'calc(' + (line - 1) + ' * 1.5em)'"></div>
        }
        <pre class="language-{{language}}"><code
            #codeElement
            [innerHTML]="highlightedCode"
            class="language-{{language}}"></code></pre>
    </div>

    <div class="legacy-content" style="display:none;white-space: pre"><ng-content /></div>
</div>